import { lazy, Suspense, ComponentType } from 'react';
import { ApexOptions } from 'apexcharts';

// Lazy load the Chart component to reduce initial bundle size
const ChartComponent = lazy(() => import('./Chart').then(mod => ({ default: mod.Chart })));

type PropsChart = {
  type: "line"
  | "area"
  | "bar"
  | "pie"
  | "donut"
  | "radialBar"
  | "scatter"
  | "bubble"
  | "heatmap"
  | "treemap"
  | "boxPlot"
  | "candlestick"
  | "radar"
  | "polarArea"
  | "rangeBar",
  series?: any[];
  width?: string | number;
  height?: string | number;
  options?: object;
}

// Fallback component while chart is loading
function ChartFallback({ height = 350 }: { height?: string | number }) {
  return (
    <div 
      style={{ 
        width: '100%', 
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.02)',
        borderRadius: '4px'
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading chart...</span>
      </div>
    </div>
  );
}

export function ChartLazy(props: PropsChart) {
  return (
    <Suspense fallback={<ChartFallback height={props.height} />}>
      <ChartComponent {...props} />
    </Suspense>
  );
}

export default ChartLazy;
